<section #sectionRef id="contact" class="section-padding bg-mint/10 relative overflow-hidden">
  <!-- Decorative Circles -->
  <div class="absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-mint/30 filter blur-3xl"></div>
  <div class="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-peach/20 filter blur-3xl"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="glass-card rounded-2xl p-8 md:p-12 shadow-lg backdrop-blur-sm border border-white/30 bg-white/50 max-w-5xl mx-auto appear-on-scroll opacity-0">
      <div class="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
        <div class="lg:col-span-3">
          <span class="subtitle mb-3">Join Our Community</span>
          <h2 class="heading-lg mb-5">Begin Your Wellness Journey Today</h2>
          <p class="body-md text-forest/80 mb-6">
            Subscribe to receive exclusive offers, wellness tips, and be the first to know about new product releases.
          </p>

          <form class="flex flex-col sm:flex-row gap-3 mb-6" name="mailling-list-form">
            <input
              type="email"
              placeholder="Your email address"
              aria-label="Email address"
              name="email"
              [(ngModel)]="email"
              class="flex-grow py-3 px-4 rounded-md border border-mint focus:outline-none focus:ring-2 focus:ring-mint"
            />
            <button type="submit" class="button-primary whitespace-nowrap flex items-center justify-center gap-2 group" (click)="onSubscribe()">
              <span>Subscribe</span>
              <!-- ArrowRight Icon -->
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7-7l7 7-7 7" />
              </svg>
            </button>
          </form>

          <p class="text-xs text-forest/60">
            By subscribing, you agree to receive marketing communications from us.
            You can unsubscribe at any time.
          </p>
        </div>

        <div class="lg:col-span-2">
          <div class="bg-white/70 rounded-xl p-6 shadow-sm space-y-5">
            <div class="space-y-2">
              <h3 class="font-cormorant text-xl font-semibold">Customer Support</h3>
              <p class="text-sm text-forest/80">We're here to help with any questions about our products.</p>
            </div>

            <!-- Email Support -->
            <div class="flex items-center gap-4 py-1">
              <div class="p-2 bg-mint/20 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-forest" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <div class="text-sm font-medium">Email Us</div>
                <a href="mailto:support@arthawell.com" class="text-sm text-forest/80 hover:text-mint-dark">support{{'@'}}arthawell.com</a>
              </div>
            </div>

            <!-- Phone Support -->
            <div class="flex items-center gap-4 py-1">
              <div class="p-2 bg-mint/20 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-forest" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div>
                <div class="text-sm font-medium">Call Us</div>
                <a href="tel:+917599393032" class="text-sm text-forest/80 hover:text-mint-dark">+91 (759) 939-3032</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
